var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128",
    id: "ai",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: "M48.0352 103.143C49.8831 106.809 55.1169 106.809 56.9648 103.143L63.4442 90.2896C65.1621 86.8817 67.6373 83.9124 70.6803 81.6092L82.7328 72.4868C85.376 70.4861 85.376 66.5139 82.7328 64.5132L70.6803 55.3908C67.6373 53.0876 65.1621 50.1183 63.4442 46.7104L56.9648 33.857C55.1169 30.1912 49.8831 30.1912 48.0352 33.857L41.5558 46.7104C39.8379 50.1183 37.3627 53.0876 34.3197 55.3908L22.2672 64.5132C19.624 66.5139 19.624 70.4861 22.2672 72.4868L34.3197 81.6092C37.3627 83.9124 39.8379 86.8817 41.5558 90.2896L48.0352 103.143zM94.5975 43.1146C95.9903 45.9331 100.01 45.9331 101.402 43.1146V43.1146C102.681 40.5271 104.533 38.2653 106.818 36.5014L107.427 36.0311C109.74 34.2452 109.74 30.7548 107.427 28.9689L106.818 28.4986C104.533 26.7347 102.681 24.4729 101.402 21.8854V21.8854C100.01 19.0669 95.9903 19.0669 94.5975 21.8854V21.8854C93.3189 24.4729 91.4669 26.7347 89.1824 28.4986L88.5732 28.9689C86.2602 30.7548 86.2602 34.2452 88.5732 36.0311L89.1824 36.5014C91.4669 38.2653 93.3189 40.5271 94.5975 43.1146V43.1146z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGenerate);
export default __webpack_public_path__ + "static/media/ai-generate.e572f275db8a111c7948f0786efe49e8.svg";
export { ForwardRef as ReactComponent };